module.exports = __webpack_public_path__ + "static/023-e9a335cfba8795bb20fdc9dd52cb0f42.jpg";